<template>
  <router-link :to="to" class="app-link" @click.prevent>
    <slot />
    <span class="app-link__text">
      {{ text }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'CardSingleCompanyLink',

  props: {
    text: {
      type: String,
      default: 'Link',
    },
    to: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.app-link__text {
  pointer-events: none;
}
</style>
